import React, { memo } from 'react';
import { SavingsNotice } from '../../../../services/quote.interfaces';

interface QuoteSavingsNoticeProps {
  savingsNotice: SavingsNotice;
}

const QuoteSavingsNotice: React.FC<QuoteSavingsNoticeProps> = ({
  savingsNotice
}) => {
  return (
    <div className="bg-text/body-support-success w-full flex flex-col items-center px-10 py-8 text-system/white text-center gap-y-3">
      <p className='text-2xl font-dm-serif-display'>{savingsNotice.text}</p>
      <p className='text-sm font-dm-sans'>{savingsNotice.subText}</p>
    </div>
  )
};

export default memo(QuoteSavingsNotice);